<template>
    <div>
        <form @submit.prevent="submit()">
            <div class="mdn-Row">
                <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <SGPFormInputComponent 
                        name="ctrl_tarefa_origem_id"
                        v-model="tarefa.tarefa"
                        data-vv-as="Tarefa Origem"
                        placeholder="Tarefa Origem"
                        readOnly
                    />
                </div>
                <!-- <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <SGPFormSelectComponent
                        name="paralelismo"
                        :listaDeOptions="opcoesSelect"
                        v-model="formulario.paralelismo"
                        data-vv-as="Paralelismo"
                        optionLabel="nome"
                        placeholder="Paralelismo"
                        v-validate="'required'"
                        :error="validationErrors.first('paralelismo')"
                    />
                </div>
                <div class="mdn-Col-xs mdn-u-marginTop--xs" v-if="formulario.paralelismo == 1">
                    <SGPFormSelectComponent
                        name="ctrl_tipo_paralelismo_id"
                        :listaDeOptions="listaDeTiposParalelismo"
                        v-model="formulario.ctrl_tipo_paralelismo_id"
                        data-vv-as="Tipo de Paralelismo"
                        optionLabel="tipo"
                        placeholder="Tipo de Paralelismo"
                        v-validate="'required'"
                        :error="validationErrors.first('ctrl_tipo_paralelismo_id')"
                    />
                </div> -->
                <!-- <div class="mdn-Col-xs mdn-u-marginTop--xs" v-if="exibirTarefaCondicional">
                    <SGPFormSelectComponent
                        name="ctrl_tarefa_condicional_id"
                        selecaoMultipla
                        :listaDeOptions="listaDeTarefas"
                        v-model="formulario.ctrl_tarefa_condicional_id"
                        data-vv-as="Tarefa Condicional"
                        optionLabel="tarefa"
                        placeholder="Tarefa Condicional"
                        v-validate="'required'"
                        :error="validationErrors.first('ctrl_tarefa_condicional_id')"
                    />
                </div> -->
                <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <SGPFormSelectComponent 
                        name="ctrl_tarefa_destino_id"
                        :listaDeOptions="listaDeTarefas"
                        v-model="formulario.ctrl_tarefa_destino_id"
                        data-vv-as="Tarefa Destino"
                        optionLabel="tarefa"
                        placeholder="Tarefa Destino"
                        v-validate="'required|max:255'"
                        :error="validationErrors.first('ctrl_tarefa_destino_id')"
                    />
                </div>
            </div> 

            <div class="mdn-Row">
                <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <SGPFormSelectComponent 
                        name="ctrl_tratativa_id"
                        :listaDeOptions="tratativasFiltradas"
                        v-model="formulario.ctrl_tratativa_id"
                        data-vv-as="Tratativa"
                        optionLabel="tratativa"
                        placeholder="Selecione uma Tratativa"
                        v-validate="'required'"
                        :error="validationErrors.first('ctrl_tratativa_id')"
                    />
                </div>
                <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <SGPFormSelectComponent 
                        name="ctrl_formulario_id"
                        :listaDeOptions="listaDeCtrlFormulariosDinamicos"
                        v-model="formulario.ctrl_formulario_id"
                        data-vv-as="Formulário"
                        optionLabel="titulo"
                        placeholder="Formulário"
                        clearable
                    />
                </div>
            </div>  

            <div class="mdn-Row">
                <div class="mdn-Col-xs mdn-u-marginTop--xs">
                    <div class="container-botoes">
                        <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
                        {{ tipoFormularioLocal === 'salvar' ? 'Salvar' : 'Atualizar' }}
                        </button>
                        <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="cancelarEdicao()">Cancelar</button>
                    </div>
                </div>
            </div>
        </form>

        <SGPTabelaComponent
            v-if="listaDeMobilidadesFormulario.length"
            :colunas="colunas"
            :dados="listaDeMobilidadesFormulario"
            :usuarioPodeExcluir="true"
            :usuarioPodeEditar="true"
            :somenteLeitura="false"
            @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
            @sgpTabelaEditarSelecionadoEmit="editarMobilidade"
            @sgpTabelaDeletarSelecionadoEmit="deletarMobilidade"
        >
        </SGPTabelaComponent>
        
        <SGPLoadingComponent v-if="loadingTarefasMobilidades" />

        <SGPConfirmacaoDelecaoComponent
            v-if="abrirModalConfirmacao"
            @sgpCancelarDelecaoEmit="cancelarDelecao()"
            @sgpConfirmarDelecaoEmit="confirmarDelecao()"
        />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

    export default {
        name: 'FormularioMobilidadeComponent',  
        
        props: {
            tipoFormulario: {
                type: String,
                required: false,
                default: 'salvar'
            },
            tarefa: {
                type: Object,
                required: true
            }
        },

        data (){
            return {
                tipoFormularioLocal: 'salvar',
                formulario:{
                    ctrl_tarefa_origem_id: this.$props.tarefa.id,
                    ctrl_tarefa_destino_id: '',
                    ctrl_tratativa_id: '',
                    ctrl_formulario_id: '',
                },
                mobilidadeParaDeletar: null,
                abrirModalConfirmacao: false,
                mobilidadesSelecionadas: [],
            }
        },
        
        created () {
            this.listarMobilidadesPorTarefaOrigem({ ctrl_tarefa_id: this.$props.tarefa.id });
            this.listarTarefas();
            this.listarTratativas();
            this.listarFormulariosDinamicos();
        },

        methods:{
            ...mapActions ('ctrlTarefasMobilidades', [
                'cadastrarTarefaMobilidade',
                'atualizarTarefaMobilidade',
                'excluirTarefaMobilidade',
                'listarMobilidadesPorTarefaOrigem'
            ]),

            ...mapActions ('ctrlTratativas', [
                'listarTratativas'
            ]),

            ...mapActions ('ctrlTarefas', [
                'listarTarefas'
            ]),

            ...mapActions ('ctrlFormularioDinamico', [
                'listarFormulariosDinamicos'
            ]),

            fecharModal () {
                this.$parent.$parent.$parent.$parent.fecharModal()
            },

            gerenciadorDeSelecionados(selecionadas) {
                this.mobilidadesSelecionadas = selecionadas;
            },

            cancelarEdicao () {
                this.tipoFormularioLocal = 'salvar';
                this.formulario = {
                    ctrl_tarefa_origem_id: this.$props.tarefa.id,
                    ctrl_tarefa_destino_id: '',
                    ctrl_tratativa_id: '',
                    ctrl_formulario_id: '',
                };
                this.$validator.reset();
                this.fecharModal(); 
            },

            validate: function () {
                this.$validator.validateAll();
            },

            submit () {
                // invoca o vee validade para a validação dos campos
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        // eslint-disable-next-line
                        if(this.tipoFormularioLocal === 'salvar') {
                            const resp = await this.cadastrarTarefaMobilidade(this.formulario);     
                            this.listarMobilidadesPorTarefaOrigem({ ctrl_tarefa_id: this.$props.tarefa.id });
                            if(!resp) { 
                                return;
                            }
                            // Limpar formulário após salvar
                            this.formulario = {
                                ctrl_tarefa_origem_id: this.$props.tarefa.id,
                                ctrl_tarefa_destino_id: '',
                                ctrl_tratativa_id: '',
                                ctrl_formulario_id: '',
                            };
                            
                            this.$validator.reset();
                        } else if (this.tipoFormularioLocal === 'editar') {
                            const resp = await this.atualizarTarefaMobilidade(this.formulario);
                            this.listarMobilidadesPorTarefaOrigem({ ctrl_tarefa_id: this.$props.tarefa.id });
                            if(!resp) { 
                                return;
                            }
                            // Resetar para modo salvar após editar
                            this.tipoFormularioLocal = 'salvar';
                            this.formulario = {
                                ctrl_tarefa_origem_id: this.$props.tarefa.id,
                                ctrl_tarefa_destino_id: '',
                                ctrl_tratativa_id: '',
                                ctrl_formulario_id: '',
                            };
                            this.$validator.reset();
                        }
                        return;
                    }
                }); 
            },

            recuperaTipoTarefaId(tarefaId){
                return this.listaDeTarefas.filter(tarefa => tarefa.id == tarefaId)[0]
            },

            editarMobilidade() {
                // Se vier do gerenciadorDeSelecionados, será um array
                const itemParaEditar = Array.isArray(this.mobilidadesSelecionadas) ? this.mobilidadesSelecionadas[0] : this.mobilidadesSelecionadas;
                
                this.tipoFormularioLocal = 'editar';
                this.formulario = {
                    id: itemParaEditar.id,
                    ctrl_tarefa_origem_id: itemParaEditar.ctrl_tarefa_origem_id,
                    ctrl_tarefa_destino_id: itemParaEditar.ctrl_tarefa_destino_id,
                    ctrl_tratativa_id: itemParaEditar.ctrl_tratativa_id,
                    ctrl_formulario_id: itemParaEditar.ctrl_formulario_id,
                };
            },

            deletarMobilidade() {
                const itemParaDeletar = Array.isArray(this.mobilidadesSelecionadas) ? this.mobilidadesSelecionadas[0] : this.mobilidadesSelecionadas;
                
                this.mobilidadeParaDeletar = itemParaDeletar;
                this.abrirModalConfirmacao = true;
            },

            confirmarDelecao() {
                if (!this.mobilidadeParaDeletar || !this.mobilidadeParaDeletar.id) {
                    this.abrirModalConfirmacao = false;
                    return;
                }

                this.excluirTarefaMobilidade(this.mobilidadeParaDeletar.id).then(() => {
                    this.listarMobilidadesPorTarefaOrigem({ ctrl_tarefa_id: this.$props.tarefa.id });
                    this.abrirModalConfirmacao = false;
                    this.mobilidadeParaDeletar = null;
                }).catch(() => {
                    this.abrirModalConfirmacao = false;
                    this.mobilidadeParaDeletar = null;
                });
            },

            cancelarDelecao() {
                this.abrirModalConfirmacao = false;
                this.mobilidadeParaDeletar = null;
            }
        },

        computed: {
            ...mapGetters('ctrlTarefas', ['listaDeTarefas']),
            ...mapGetters('ctrlTratativas', ['listaDeTratativas']),
            ...mapGetters('ctrlFormularioDinamico', ['listaDeCtrlFormulariosDinamicos']),
            ...mapGetters('ctrlTarefasMobilidades', ['listaDeTarefasMobilidades', 'loadingTarefasMobilidades']),

            tratativasFiltradas() {
                return this.listaDeTratativas.filter(tratativa => {
                    return !['Adotado', 'Atualizar'].includes(tratativa.tratativa)
                })
            },

            listaDeMobilidadesFormulario(){
                return this.listaDeTarefasMobilidades.map(item => {
                    return item;
                })
            },

            colunas () {
                return [
                    {
                        key: 'selecionar',
                        label: '',
                        sortable: false
                    }, 
                    {
                      key: 'tarefa_destino.tarefa',
                      label: 'Tarefa Destino',
                      sortable: false
                    },
                    {
                      key: 'ctrl_tratativa.tratativa',
                      label: 'Tratativa',
                      sortable: false
                    },
                    {
                        key: 'ctrl_formulario.titulo',
                        label: 'Formulário',
                        sortable: false
                    }
                ]
            }
        }
    }
</script>
